module.exports = __webpack_public_path__ + "img/hr-branch-particle-29.139b05ff.png";